<template>
  <div class="d-flex flex-column" style="min-height: 100vh;">
    <main-header
      v-if="routeCheckForHeader"
      :auth="auth"
      :isMobile="isMobile"
      :menu="menu"
      :mobileMenuIsOpened="mobileMenuIsOpened"
      @logout="logout()"
      @mobileMenuHandle="mobileMenuIsOpened = !mobileMenuIsOpened"
    />
    <div v-show="!mobileMenuIsOpened" class="content-container-app" style="flex: 1">
      <slot></slot>
    </div>
    <div v-show="mobileMenuIsOpened" class="mobile-menu" :class="{isActive: mobileMenuIsOpened}">
      <div v-for="(el, elIndex) in headerNav" :key="elIndex" @click="routeChange(el.link)" class="mobile-menu__row">
        <span class="mobile-menu__row-text">{{ el.text }}</span>
        <img src="@/profile/assets/icons/arrow-right.svg" alt="menu">
      </div>
      <div v-for="(el, elIndex) in menu" :key="elIndex" @click="routeChange(el.path)" class="mobile-menu__row">
        <span class="mobile-menu__row-text">{{ el.name }}</span>
        <img src="@/profile/assets/icons/arrow-right.svg" alt="menu">
      </div>
      <div class="mobile-menu__row" @click="logout()">
        <a class="mobile-menu__row-text" :href="/profile/">Выйти</a>
        <img src="@/profile/assets/icons/arrow-right.svg" alt="menu">
      </div>
    </div>
    <main-footer v-if="routeCheckForFooter" />
  </div>
</template>

<script>
import MainHeader from "@/profile/components/layout/MainHeader.vue";
import MainFooter from "@/profile/components/layout/MainFooter.vue";
import { headerNav } from "@/profile/components/layout/navigation";

export default {
  components: {
    MainHeader,
    MainFooter
  },
  props: {
    auth: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      mobileMenuIsOpened: false,
      headerNav: headerNav,
      menu: {}
    };
  },
  computed: {
    routeCheckForHeader() { // не показывать меню при путях авторизации
      if (this.$router.currentRoute.value.name !== "login"
        && this.$router.currentRoute.value.name !== "signin"
        && this.$router.currentRoute.value.name !== "forgot"
        && this.$router.currentRoute.value.name !== "changepass"
        && !this.$route.params.token) {
        return true;
      } else {
        return false;
      }
    },
    routeCheckForFooter() { // не показывать меню при путях авторизации
      if (!this.$route.params.token) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async logout() {
      let params = {
        action: "logout",
        object: "cpa",
        token: this.$myApp.token.get()
      };
      let api = await this.$api2.get(params);
      if (api.success) {
        window.location.href = "https://" + window.location.host;
      }
    },
    routeChange(arg) {
      this.$router.push({ name: `${arg}` });
      this.mobileMenuIsOpened = false;
    }
  },
  beforeMount() {
    //Подписываемся на изменение меню
    this.$myApp.menu.on((value) => {
      this.menu = value;
    });
  }
};

</script>

<style scoped lang="scss">
.layoutMain {
  margin: 42px 60px 36px 36px;
  min-width: 1440px;
}
</style>
